import React from "react";
import { MdInfo } from "react-icons/md";

interface DetailsButtonProps {
  onClick: () => void;
}

// The small brand-coloured "Details" action in history tables and their
// mobile cards. Stops propagation so a clickable row does not also fire.
const DetailsButton: React.FC<DetailsButtonProps> = ({ onClick }) => (
  <button
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    className="inline-flex items-center rounded-md bg-biafit-primary px-3 py-1.5 text-xs font-medium text-white transition-colors hover:bg-biafit-secondary"
  >
    <MdInfo className="mr-1 h-3 w-3" />
    Details
  </button>
);

export default DetailsButton;
